import { useNavigate } from 'react-router-dom';
import { Translate } from "./Translator"

import './Header.css'
import './MainMenu.css'

function MainMenu(props){

    const navigate = useNavigate();
    const mIsTenantAdmin = sessionStorage.getItem("UserIsTenantAdmin");

    return(
        <span>
            <table className="mainmenubar" width="100%" cellPadding={0} cellSpacing={0} align="center">
                <tbody>                
                    <tr className="pagetop2">
                        <td width="*"/>
                        <td width="1200" height="150" valign="bottom">
                            <table width="100%" cellPadding={0} cellSpacing={0} className="down10px">
                                <tbody>
                                    <tr height="60">
                                        <td width="220" className={props.MainMenuNumber === 1 ? "mainmenuitemselected" : "mainmenuitem" } onClick={() => navigate('../')}>{Translate("Installation")}</td>
                                        {mIsTenantAdmin === "1" && <td width="220" className={props.MainMenuNumber === 2 ? "mainmenuitemselected" : "mainmenuitem" }
                                                                        onClick={() => navigate('../tenant')}>{Translate("Tenant")}
                                                                    </td>
                                        }
                                        <td width="220" className={props.MainMenuNumber === 4 ? "mainmenuitemselected" : "mainmenuitem"} onClick={() => navigate('../support')}>{Translate("Support")}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td width="*"/>
                    </tr>
                </tbody>
            </table>
        </span>
    )

}

export default MainMenu